import React from 'react';
import styled from 'styled-components';

export function Seperator({ width, height, style }) {
    if (!width)
        width = 0;
    if (!height)
        height = 0;
    return (
        <Container style={
            width > height ? { width: `${width}px`, height: "3px", ...style } :
                width < height ? { width: "3px", height: `${height}px`, ...style } : { style }}>
            <Line style={
                width > height ? { width: `${width}px`, height: "1px" }
                    : width < height ? { width: "1px", height: `${height}px` } : { style }} />
        </Container>
    );
}

const Container = styled.div`
    justify-content: center;
    align-items: center;
    display: flex;
`;

const Line = styled.div`
    background: #CCC;
`;